// import * as L from "leaflet";
import { decode } from "@mapbox/polyline";
import { CircularProgress } from "@material-ui/core";
import { length, lineString } from "@turf/turf";
import "leaflet/dist/leaflet.css";
import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { clearIntervalAsync } from "set-interval-async";
import { setIntervalAsync } from "set-interval-async/dynamic";
import EtaCard from "../../components/EtaCard";
import MapComp from "../../components/Map/index";
import { getRouteStopEta, getRouteTraffic, getStop } from "../../utils/api";
import { hideStopDroppingStragegy, langStringConvertor } from "../../utils/utils";
import "./styles.scss";
import turf from "turf";



const Eta = (props) => {
  const {
    lang,
    routes,
    displayType,
    setCurrentTitle,
    court,
    firstStopEtaRoutes,
    fakeCircularRoutes,
    vehicleLocationAlwaysShow,
    overrideDepartureTimeRoutes,
    vehicleIconBearing,
    hideStop,
    trafficMessage,
    etaDisplayMethod,
    stopColor,
    vehicleColor,
    themeColour,
    showLicensePlate,
    showLicensePlateOnMap
  } = props;
  const { routeId, routeSeq } = props.match.params;

  const urlParams = new URLSearchParams(window.location.search);
  const lat = urlParams.get("lat");
  const lng = urlParams.get("lng");

  const route = routes.find((el) => `${el.route_id}` === routeId);
  const directionsStops = route?.routeStops;
  const [path, setPath] = useState([]);
  const [stops, setStops] = useState([]);
  const [vehicleLocations, setVehicleLocations] = useState(null);
  const [traffic, setTraffic] = useState([]);
  const [etaCardMsg, setEtaCardMsg] = useState(null);

  // FOR COMBINESTOPS DISPLAY TYPE
  const [path2, setPath2] = useState([]);
  const [stops2, setStops2] = useState([]);
  const [vehicleLocations2, setVehicleLocations2] = useState(null);
  const [traffic2, setTraffic2] = useState([]);

  const [bounds, setBounds] = useState(new window.google.maps.LatLngBounds());

  const [isLoading, setIsLoading] = useState(true);

  const [isFirstTime, setIsFirstTime] = useState(true);

  const [nearestStop, setNearestStop] = useState(undefined);

  const getStopsInfo = useCallback(async () => {
    let oppoEta;

    const tempEta = await getRouteStopEta(routeId, routeSeq);
    setVehicleLocations(tempEta?.vehicleLocation);

    if (
      (firstStopEtaRoutes &&
        firstStopEtaRoutes.includes(parseInt(routeId, 10))) ||
      (overrideDepartureTimeRoutes &&
        overrideDepartureTimeRoutes.includes(parseInt(routeId, 10)))
    ) {
      // console.log("add");

      oppoEta = await getRouteStopEta(routeId, routeSeq === "1" ? 2 : 1);
    }

    if (directionsStops && directionsStops.length > 0) {
      await Promise.all(
        directionsStops[directionsStops?.length > 1 ? routeSeq - 1 : 0].map(
          async (stop, index) => {
            const tempStopInfo = await getStop(stop.stop_id);
            const stationEta = tempEta?.eta.find(
              (el) => el.stopSeq === index + 1
            );

            if (
              firstStopEtaRoutes &&
              firstStopEtaRoutes.includes(parseInt(routeId, 10)) &&
              index === 0 &&
              stationEta?.eta &&
              oppoEta.eta.length > 0
            ) {
              stationEta.eta = oppoEta?.eta[oppoEta?.eta.length - 1]?.eta;
              console.log(stationEta.eta, oppoEta);
            }

            if (
              overrideDepartureTimeRoutes &&
              overrideDepartureTimeRoutes.includes(parseInt(routeId, 10)) &&
              index === 0 &&
              stationEta?.eta &&
              oppoEta.eta.length > 0
            ) {
              // console.log("add", oppoEta, stationEta);
              if (
                overrideDepartureTimeRoutes &&
                overrideDepartureTimeRoutes.includes(parseInt(routeId, 10)) &&
                oppoEta?.eta?.[oppoEta?.eta.length - 1]?.eta?.[0].diff <
                  stationEta?.eta?.[0].diff
              ) {
                // console.log("larger");
              } else {
                stationEta?.eta.push(
                  oppoEta.eta[oppoEta.eta.length - 1].eta[0]
                );
                stationEta?.eta.sort((a, b) => (a.diff < b.diff ? -1 : 1));
                const temp = stationEta?.eta.map((el, index) => ({
                  ...el,
                  eta_seq: index + 1,
                }));
                console.log(stationEta);
                stationEta.eta = temp;
                // console.log(temp);
                // console.log("smaller");
              }
            }

            return { ...stop, ...tempStopInfo, eta: stationEta?.eta || null };
          }
        )
      ).then((result) => {
        setStops(result);
      });
    }
  }, [
    directionsStops,
    firstStopEtaRoutes,
    overrideDepartureTimeRoutes,
    routeId,
    routeSeq,
  ]);

  const getEta = useCallback(async () => {
    let oppoEta;
    const tempEta = await getRouteStopEta(routeId, routeSeq);
    setVehicleLocations(tempEta?.vehicleLocation);

    if (
      (firstStopEtaRoutes &&
        firstStopEtaRoutes.includes(parseInt(routeId, 10))) ||
      (overrideDepartureTimeRoutes &&
        overrideDepartureTimeRoutes.includes(parseInt(routeId, 10)))
    ) {
      oppoEta = await getRouteStopEta(routeId, routeSeq === "1" ? 2 : 1);
    }
    await Promise.all(
      stops.map((stop, index) => {
        const stationEta = tempEta?.eta.find((el) => el.stopSeq === index + 1);
        if (
          firstStopEtaRoutes &&
          firstStopEtaRoutes.includes(parseInt(routeId, 10)) &&
          index === 0 &&
          stationEta?.eta &&
          oppoEta.eta.length > 0
        ) {
          stationEta.eta = oppoEta?.eta[oppoEta?.eta.length - 1]?.eta;
          console.log(stationEta.eta, oppoEta);
        }
        if (
          overrideDepartureTimeRoutes &&
          overrideDepartureTimeRoutes.includes(parseInt(routeId, 10)) &&
          index === 0 &&
          stationEta?.eta &&
          oppoEta.eta.length > 0
        ) {
          if (
            overrideDepartureTimeRoutes &&
            overrideDepartureTimeRoutes.includes(parseInt(routeId, 10)) &&
            oppoEta?.eta?.[oppoEta?.eta.length - 1]?.eta?.[0].diff <
              stationEta?.eta?.[0]?.diff
          ) {
          } else {
            stationEta?.eta.push(oppoEta.eta[oppoEta.eta.length - 1].eta[0]);
            stationEta?.eta.sort((a, b) => (a.diff < b.diff ? -1 : 1));
            const temp = stationEta?.eta.map((el, index) => ({
              ...el,
              eta_seq: index + 1,
            }));
            stationEta.eta = temp;
          }
        }

        return { ...stop, eta: stationEta?.eta || null };
      })
    ).then((result) => {
      setStops(result);
    });
  }, [
    firstStopEtaRoutes,
    overrideDepartureTimeRoutes,
    routeId,
    routeSeq,
    stops,
  ]);

  const getPath = useCallback(async () => {
    const tempBounds = bounds || new window.google.maps.LatLngBounds();
    if (route) {
      const tempPath = decode(
        route.directions.find((el) => `${el.route_seq}` === `${routeSeq}`).shape
      );
      if (tempPath.length > 0) {
        const pathCoords = tempPath.map((latlng) => {
          const latLng = new window.google.maps.LatLng(latlng[0], latlng[1]);
          tempBounds.extend(latLng);
          return { lat: latlng[0], lng: latlng[1] };
        });
        setBounds(tempBounds);
        setPath(pathCoords);
      }
    }
  }, [bounds, route, routeSeq]);

  const getTraffic = useCallback(async () => {
    if (route) {
      const tempTraffic = await getRouteTraffic(routeId, routeSeq);
      if (tempTraffic.length > 0) {
        setTraffic(tempTraffic);

        // calculate traffic portion
        const segments = tempTraffic.map(el => {
          const path = decode(el.segment).map((el) =>[el[1], el[0]]);
          const ls = lineString(path);
          const l = length(ls, { units: 'metres' });

          return {
            length: l,
            trafficLevel: el.trafficLevel
          };
        });

        const totalLength = segments.reduce((acc, curr) => {
          return acc + curr.length;
        }, 0);
        
        const trafficSlowLength = segments.reduce((acc, curr) => {
          return acc + (['good', 'average'].includes(curr.trafficLevel) ? 0 : curr.length)
        }, 0);

        const portion = trafficSlowLength / totalLength;

        if (portion > 0.15 && trafficMessage === 'showTrafficMessageOnEveryStop') {
          setEtaCardMsg(['zh', 'cn'].includes(lang) 
            ? '因沿途交通阻塞，班次可能有所延誤。' 
            : 'Due to severe traffic congestion en route, this route may be diverted');
        }
      }
    }
  }, [route, routeId, routeSeq, trafficMessage]);

  /**
   *  FOR COMBINESTOPS DISPLAY TYPE
   */

  const getStopsInfo2 = useCallback(async () => {
    const tempEta = await getRouteStopEta(routeId, parseInt(routeSeq) + 1);
    setVehicleLocations2(tempEta?.vehicleLocation);
    await Promise.all(
      route?.routeStops[routeSeq].map(async (stop, index) => {
        const tempStopInfo = await getStop(stop.stop_id);
        const stationEta = tempEta?.eta.find((el) => el.stopSeq === index + 1);

        return { ...stop, ...tempStopInfo, eta: stationEta?.eta || null };
      })
    ).then((result) => {
      setStops2(result);
    });
  }, [route?.routeStops, routeId, routeSeq]);

  const getEta2 = useCallback(async () => {
    const tempEta = await getRouteStopEta(routeId, parseInt(routeSeq) + 1);
    // console.log(tempEta);
    setVehicleLocations2(tempEta?.vehicleLocation);
    await Promise.all(
      stops2.map((stop, index) => {
        const stationEta = tempEta?.eta.find((el) => el.stopSeq === index + 1);
        return { ...stop, eta: stationEta?.eta || null };
      })
    ).then((result) => {
      setStops2(result);
      // console.log(result);
    });
  }, [routeId, routeSeq, stops2]);

  const getPath2 = useCallback(async () => {
    const tempBounds = bounds || new window.google.maps.LatLngBounds();
    if (route) {
      const tempPath = decode(route.directions[routeSeq].shape);
      if (tempPath.length > 0) {
        const pathCoords = tempPath.map((latlng) => {
          const latLng = new window.google.maps.LatLng(latlng[0], latlng[1]);
          tempBounds.extend(latLng);
          return { lat: latlng[0], lng: latlng[1] };
        });
        setBounds(tempBounds);
        setPath2(pathCoords);
      }
    }
  }, [bounds, route, routeSeq]);

  const getTraffic2 = useCallback(async () => {
    if (route) {
      const tempTraffic = await getRouteTraffic(
        routeId,
        parseInt(routeSeq) + 1
      );
      if (tempTraffic.length > 0) {
        setTraffic2(tempTraffic);
      }
    }
  }, [route, routeId, routeSeq]);

  /**
   * GET OPPOSITE ETA for First Stop Eta -- END
   */

  const getCurrentTitle = useCallback(() => {
    // console.log(routes);
    // console.log(routeId);
    if (route) {
      const origin = route?.directions.find(
        (el) => `${el.route_seq}` === `${routeSeq}`
      )[`orig_${langStringConvertor(lang)}`];
      const destination = route?.directions.find(
        (el) => `${el.route_seq}` === `${routeSeq}`
      )[`dest_${langStringConvertor(lang)}`];

      setCurrentTitle(
        lang === "zh" || lang === "cn"
          ? displayType === "combineStops" ||
            (fakeCircularRoutes &&
              fakeCircularRoutes.includes(parseInt(routeId, 10)))
            ? `來往 ${destination}`
            : `由 ${origin} 往 ${destination}`
          : displayType === "combineStops" ||
            (fakeCircularRoutes &&
              fakeCircularRoutes.includes(parseInt(routeId, 10)))
          ? `To ${destination}`
          : `From ${origin} To ${destination}`
      );
    }
  }, [
    displayType,
    fakeCircularRoutes,
    lang,
    route,
    routeId,
    routeSeq,
    setCurrentTitle,
  ]);

  useEffect(() => {
    const getData = async () => {
      await getStopsInfo();
      await getPath();
      await getTraffic();
      if (
        displayType === "combineStops" ||
        (fakeCircularRoutes &&
          fakeCircularRoutes.includes(parseInt(routeId, 10)))
      ) {
        await getStopsInfo2();
        await getPath2();
        await getTraffic2();
      }
    };

    if (isFirstTime && routes && routes?.length > 0) {
      getCurrentTitle();
      getData();
      setIsFirstTime(false);
      setIsLoading(false);
    }
  }, [
    displayType,
    fakeCircularRoutes,
    getCurrentTitle,
    getPath,
    getPath2,
    getStopsInfo,
    getStopsInfo2,
    getTraffic,
    getTraffic2,
    isFirstTime,
    routeId,
    routes,
    setCurrentTitle,
  ]);

  useEffect(() => {
    if (lat && lng) {
      const userCoord = [Number(lng), Number(lat)];
      setNearestStop(_.minBy(
        [...stops, ...stops2],
        x => turf.distance(userCoord, [x.coordinates.wgs84.longitude, x.coordinates.wgs84.latitude])
      ));
    }
  }, [stops, stops2])

  useEffect(() => {
    getCurrentTitle();
  }, [getCurrentTitle, lang]);

  useEffect(() => {
    const timer = setIntervalAsync(async () => {
      // await getStopsInfo();
      await getEta();
      await getTraffic();
      // console.log(fakeCircularRoutes);
      if (
        displayType === "combineStops" ||
        (fakeCircularRoutes &&
          fakeCircularRoutes.includes(parseInt(routeId, 10)))
      ) {
        // await getStopsInfo2();
        // console.log("call 2");
        await getEta2();
        await getTraffic2();
      }
    }, 10000);

    return () => {
      clearIntervalAsync(timer);
    };
  }, [
    displayType,
    fakeCircularRoutes,
    getEta,
    getEta2,
    getTraffic,
    getTraffic2,
    routeId,
  ]);

  return (
    <>
      {isLoading ? (
        <div
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="progress-container"
        >
          <CircularProgress color="primary" />
        </div>
      ) : (
        <>
          {path.length > 0 ? (
            displayType === "combineStops" ||
            fakeCircularRoutes?.includes(parseInt(routeId, 10)) ? (
              path2.length > 0 && (
                <MapComp
                  path={path}
                  stops={stops}
                  path2={path2}
                  stops2={stops2}
                  bounds={bounds}
                  court={court}
                  vehicleLocations={vehicleLocations}
                  vehicleLocations2={vehicleLocations2}
                  traffic={traffic}
                  traffic2={traffic2}
                  themeColour={themeColour}
                  focusStop={nearestStop}
                  showLicensePlate={showLicensePlateOnMap}
                  loadingElement={
                    <div id="gmap-native-loading" style={{ height: `100%` }} />
                  }
                  containerElement={
                    <div
                      id="gmap-container"
                      style={{
                        height: displayType === "noETA" ? `100%` : `50%`,
                        position: "relative",
                      }}
                    />
                  }
                  mapElement={
                    <div
                      id="gmap-map"
                      style={{
                        height: `100%`,
                        width: "100%",
                        position: "absolute",
                        zIndex: 1,
                      }}
                    />
                  }
                />
              )
            ) : (
              <MapComp
                path={path}
                stops={stops}
                bounds={bounds}
                court={court}
                vehicleLocations={vehicleLocations}
                traffic={traffic}
                displayType={displayType}
                vehicleLocationAlwaysShow={vehicleLocationAlwaysShow}
                vehicleColor={vehicleColor}
                stopColor={stopColor}
                themeColour={themeColour}
                focusStop={nearestStop}
                showLicensePlate={showLicensePlateOnMap}
                loadingElement={
                  <div id="gmap-native-loading" style={{ height: `100%` }} />
                }
                containerElement={
                  <div
                    id="gmap-container"
                    style={{
                      height: displayType === "noETA" ? `100%` : `50%`,
                      position: "relative",
                    }}
                  />
                }
                mapElement={
                  <div
                    id="gmap-map"
                    style={{
                      height: `100%`,
                      width: "100%",
                      position: "absolute",
                      zIndex: 1,
                    }}
                  />
                }
                vehicleIconBearing={vehicleIconBearing}
              />
            )
          ) : null}
          {stops.length > 0 &&
            displayType !== "noETA" &&
            (displayType === "combineStops" ||
            fakeCircularRoutes?.includes(parseInt(routeId, 10)) ? (
              stops2.length > 0 && (
                <EtaCard
                  stops={[...stops, stops2[stops2.length - 1]]}
                  lang={lang}
                  etaDisplayMethod={etaDisplayMethod}
                  themeColour={themeColour}
                  nearestStop={nearestStop}
                  showLicensePlate={showLicensePlate}
                  vehicleLocations={vehicleLocations}
                />
              )
            ) : (
              <EtaCard
                stops={hideStopDroppingStragegy(hideStop)(stops)}
                lang={lang}
                isRA={displayType === "ra"}
                message={etaCardMsg}
                etaDisplayMethod={etaDisplayMethod}
                themeColour={themeColour}
                nearestStop={nearestStop}
                showLicensePlate={showLicensePlate}
                vehicleLocations={vehicleLocations}
              />
            ))}
        </>
      )}
    </>
  );
};

export default Eta;

// compose(
//   withProps({
//     loadingElement: <div id="gmap-native-loading" style={{ height: `100%` }} />,
//     containerElement: (
//       <div
//         id="gmap-container"
//         style={{
//           height: `100%`,
//           position: "relative",
//         }}
//       />
//     ),
//     mapElement: (
//       <div
//         id="gmap-map"
//         style={{
//           height: `100%`,
//           width: "100%",
//           position: "absolute",
//           zIndex: 1,
//         }}
//       />
//     ),
//   }),
//   withGoogleMap
// );
